module.exports = __webpack_public_path__ + "img/bc_pic5.fb30270d.png";